export const en = {
    "activation-phrase": "Activation phrase",
    "activation-phrases": "Activation phrases",
    "android-deeplink": "Android deeplink",
    "app-name": "Application name",
    "brand-verification-website": "Brand verification website",
    "category": "Category",
    "cloud": "Yandex Cloud",
    "description": "Description",
    "description-access-hidden": "The skill will not appear in the [catalog], but any user who knows the activation phrase can activate it.",
    "description-access-hidden-yango": "Any user who knows the activation phrase can activate the skill.",
    "description-access-private": "The skill will not appear in the [catalog], and only you can activate it. Also, a private skill does not need to be moderated and tested.",
    "description-access-private-yango": "Only you can activate the skill. Also, a private skill does not need to be moderated and tested.",
    "description-access-public": "The skill will be displayed in the [catalog], and any user can activate it.",
    "description-access-public-yango": "Any user can activate the skill.",
    "description-app-access-private": "The app will not appear in the store for everybody, only you will have access to it. Also, a private app does not need to be moderated and tested.",
    "description-app-access-public": "The app will be displayed in the store, and any user can install it.",
    "description-devices-connection": "Devices Connection",
    "description-email": "The specified address can be used for direct communication with you.",
    "description-email-sent": "An email has been sent to the specified address with instructions for confirmation.",
    "description-list-of-supported-devices": "List of Supported Devices",
    "description-official": "The skill is an official brand skill and is developed by the device manufacturer or its official representative. Read more in the [documentation].",
    "description-support-url": "Support URL",
    "description-verification": "Your site address. The rights to the site must be verified for your [Yandex Webmaster] account. Verification occurs automatically after saving the settings",
    "description-verification-check": "verified via [Yandex Webmaster]",
    "developer-name": "Developer name",
    "dialog-name": "Dialog name",
    "email": "Developer email",
    "exact-surfaces": "Only these",
    "examples": "Request examples",
    "explicit-content": "Age restrictions",
    "function": "Yandex Cloud function",
    "hidden": "Hidden",
    "hide-in-store": "Privacy",
    "ios-deeplink": "iOS deeplink",
    "ios-deeplink-fallback": "iOS deeplink fallback",
    "just-name": "Name",
    "logo": "Icon",
    "banner": "App banner",
    "name": "Skill name",
    "not-verified": "Not verified",
    "note-for-moderator": "Notes for moderator",
    "private": "Private",
    "provider": "Provider",
    "public": "Public",
    "require-interfaces": "Platform restrictions",
    "send-again": "Send again",
    "skill-access": "Access type",
    "state-storage": "Storage",
    "subtitle": "Subtitle",
    "suggests": "Suggests",
    "surfaces-blacklist": "Blacklist",
    "surfaces-whitelist": "Whitelist",
    "trusted-skill": "Official skill",
    "voice": "Voice",
    "language": "Language",
    "language-description": "The language determines in which country the skill can be published",
    "select-language": "Select language",
    "selected-regions": "Choose which countries your skill supports to work:",
    "package-name": "Package name",
    "age-restriction": "Age restriction",
    "target-platforms": "Target platforms",
    "version-notes": "Version notes",
    "license-agreement": "Eula agreement",
    "privacy-agreement": "Privacy agreement",
    "screenshots": "Screenshots",
} as const;
export const ru = {
    "activation-phrase": "Активационное имя",
    "activation-phrases": "Активационные имена",
    "android-deeplink": "Android диплинк",
    "app-name": "Название приложения",
    "brand-verification-website": "Сайт для верификации прав использования бренда",
    "category": "Категория",
    "cloud": "Яндекс Облако",
    "description": "Описание",
    "description-access-hidden": "Навык не будет отображаться в [каталоге], но его сможет активировать любой пользователь, который знает активационную фразу.",
    "description-access-hidden-yango": "Навык сможет активировать любой пользователь, который знает активационную фразу.",
    "description-access-private": "Навык не будет отображаться в [каталоге], и его сможете активировать только вы. Также приватному навыку не требуется проходить модерацию и тестирование.",
    "description-access-private-yango": "Навык сможете активировать только вы. Также приватному навыку не требуется проходить модерацию и тестирование.",
    "description-access-public": "Навык будет отображаться в [каталоге], и его сможет активировать любой пользователь.",
    "description-access-public-yango": "Навык сможет активировать любой пользователь.",
    "description-app-access-private": "Приложение не будет отображаться каталоге для всех, только вы будете иметь к нему доступ. Также приватному приложению не требуется проходить модерацию и тестирование.",
    "description-app-access-public": "Приложение будет отображаться в каталоге, и его сможет установить любой пользователь.",
    "description-devices-connection": "Подключение \nустройств",
    "description-email": "Указанный адрес может быть использован для прямой связи с вами.",
    "description-email-sent": "На указанный адрес отправлено письмо с инструкцией для подтверждения.",
    "description-list-of-supported-devices": "Список поддерживаемых устройств",
    "description-official": "Навык является официальным навыком бренда, и его разработчиком является сам производитель устройств или его официальный представитель. Подробнее в [документации].",
    "description-support-url": "URL поддержки",
    "description-verification": "Адрес вашего сайта. Права на сайт должны быть подтверждены для вашего аккаунта в [Яндекс Вебмастере]. Верификация происходит автоматически после сохранения настроек",
    "description-verification-check": "проверяется через [Яндекс Вебмастер]",
    "developer-name": "Имя разработчика",
    "dialog-name": "Название диалога",
    "email": "Email разработчика",
    "exact-surfaces": "Только эти",
    "examples": "Примеры запросов",
    "explicit-content": "Возрастные ограничения",
    "function": "Функция в Яндекс Облаке",
    "hidden": "Скрытый",
    "hide-in-store": "Приватность",
    "ios-deeplink": "iOS диплинк",
    "ios-deeplink-fallback": "iOS диплинк fallback",
    "just-name": "Название",
    "logo": "Иконка",
    "banner": "Баннер приложения",
    "name": "Имя навыка",
    "not-verified": "Не проверено",
    "note-for-moderator": "Заметки для\nмодератора",
    "private": "Приватный",
    "private-do-not-need-moderation": "",
    "provider": "Провайдер",
    "public": "Публичный",
    "require-interfaces": "Ограничения на используемые платформы",
    "send-again": "Отправить снова",
    "skill-access": "Тип доступа",
    "state-storage": "Хранилище",
    "subtitle": "Подзаголовок",
    "suggests": "Саджесты",
    "surfaces-blacklist": "Черный список",
    "surfaces-whitelist": "Белый список",
    "trusted-skill": "Официальный навык",
    "voice": "Голос",
    "language": "Язык",
    "language-description": "От языка зависит в какой стране может быть опубликован навык",
    "select-language": "Выберите язык",
    "selected-regions": "В каких странах поддерживает работу ваш навык:",
    "package-name": "Package name",
    "age-restriction": "Возрастные ограничения",
    "target-platforms": "Платформы распространения",
    "screenshots": "Скриншоты",
    "license-agreement": "Лицензионное соглашение",
    "privacy-agreement": "Политика конфиденциальности",
    "version-notes": "Коментарии к версии",
} as const;
